module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Shonn Keels\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("Shonn Keels")]), _vm._v(" is a pastor in Oklahoma City with more than 25 years of experience. He has traveled to six continents, more than 35 countries, and almost every state in the US sharing the gospel and training pastors. Shonn has a Bachelor of Arts in Interdisciplinary Studies from the University of South Carolina with a minor in religious studies. He also has a Master of Arts in Ministry, a Master of Divinity, and a Doctor of Ministry from Luther Rice College and Seminary. He is the author of "), _c('I', [_vm._v("Go Fish: Reviving Personal Evangelism, The Great Debate: Calvinism or Choice, Maximize Your Leadership")]), _vm._v(", and co-author of "), _c('I', [_vm._v("Hold the Rope")]), _vm._v(". Shonn and his wife, Bonnie, have been married since 1993 and have two adult daughters, a son-in-law, and a granddaughter. They live in Oklahoma City and love cheering for the Thunder.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/wtMyi4/tc-custom/9781631956744.jpg?1701061558871",
      "alt": "This image is the cover for the book Finding Hope in Hardship"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Finding Hope in Hardship\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("With the lingering effects of the global pandemic, "), _c('i', [_vm._v("Finding Hope in Hardship")]), _vm._v(" is an answer to experiencing God's peace in the midst of pain and uncertainty."), _c('br')]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Morgan James Publishing\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0